import React from 'react';
import {List, Button} from "antd";
import PropTypes from 'prop-types';
import UserAvatar from '@web/components/UserAvatar';
import Icon from '@web/components/Icon';

ListItemMeta.propTypes = {
  data: PropTypes.object,
  mapper: PropTypes.object,
  actions: PropTypes.arrayOf(PropTypes.node),
};

function ListItemMeta(props) {
  if (!props.data) return null;
  return <List.Item.Meta
    avatar={<UserAvatar icon={<Icon name={props.data?.icon || props.data?.[props.mapper?.icon]} />} />}
    title={<span className="title">{props.data?.title || props.data?.[props.mapper?.title]}</span>}
    description={
    <div>
      <div>{props.data?.description || props.data?.[props.mapper?.description]}</div>
      <div className="space space-center-y" style={{marginTop: 10}}>{!!props.actions?.length && props.actions}</div>
    </div>}
  />;
}

export default ListItemMeta;
